import { serviceInstance } from 'libs';

export default {
  getGuides: (params) =>
    serviceInstance.get(`/v1/tour-guide`, { params }).then(({ data }) => ({
      ...data,
    })),
};
